import { render } from "./SelectedFlight.vue?vue&type=template&id=f09d5ac0&scoped=true"
import script from "./SelectedFlight.vue?vue&type=script&lang=js"
export * from "./SelectedFlight.vue?vue&type=script&lang=js"

import "./SelectedFlight.vue?vue&type=style&index=0&id=f09d5ac0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f09d5ac0"]])

export default __exports__